import React from 'react';

const ErrorMessage = ({ message, children }) => {
    return (
        <div className="text-center text-red-500 p-6">
            <p>{message}</p>
            {children}
        </div>
    );
};

export default ErrorMessage;